<template>
  <div class="p0 pos-center mobile-hidden single-internal-gutter centerMobile">
    <form @submit.prevent="$emit('update:modelValue', search)" role="search">
      <input type="text" v-model="search" placeholder="Search" class="inputSearch" name="search">
      <button class="btnSearch">
        <i class="fa fa-search"></i>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: String
  },
  data() {
    return {
      search: ''
    }
  }
}
</script>

<style scoped lang="scss">
  form {
    width: 100%;

    .inputSearch {
      width: 100%;
      float: none;
    }
  }
</style>
